<template>
	<div class="settlement">
		<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="seach">
			<el-form-item label="年份">
				<el-select v-model="select.year" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in years" :key="item.value" :label="item.value" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="select.status" placeholder="请选择" style="width: 150px;">
					<el-option v-for="item in status" :key="item.num" :label="item.value" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
				<el-button type="primary" @click="seachSettleMent">查询</el-button>
				<el-button type="primary" @click="returnSearch">重置</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="meterList" border style="width:1652px;text-align:center;margin-bottom: 10px;font-size:12px;margin-top: 10px;">
			<el-table-column prop="year" label="年份" align="center" >
			</el-table-column>
			<el-table-column prop="build" label="小区"  align="center">
			</el-table-column>
			<el-table-column prop="time" label="创建时间"  align="center">
			</el-table-column>
			<el-table-column prop="sumbit" align="center" label="操作">
				<template scope="scope">
					<el-button type="text" v-if="1 == scope.row.type" @click="sureStatus(scope.row)">审核</el-button>
					<el-tag v-if="2 == scope.row.type" type="primary">已审核</el-tag>
					<el-tag v-if="3 == scope.row.type" type="primary">已处理</el-tag>
					<el-button  type="primary"  size="mini" @click="jumpInfo(scope.row)" >详情</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="dueTime" label="自动审核倒计时间"  align="center">
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pageSize" layout="total,prev, pager, next" :total="total">
		</el-pagination>
	</div>
</template>
<script>
	function countTime(dueTime) {
			var downTime = dueTime 
             //获取当前时间  
             var date = new Date();
             var now = date.getTime();  
             //设置截止时间  
             var str= downTime
             var endDate = new Date(str);
             var end = endDate.getTime();  
             //时间差  
             var leftTime = end-now; 
             //定义变量 d,h,m,s保存倒计时的时间  
             var d=''
             var h=''
             var m=''
             var s=''
             if (leftTime>=0) {  
                 //d = Math.floor(leftTime/1000/60/60/24);  
                 h = Math.floor(leftTime/1000/60/60);  
                 m = Math.floor(leftTime/1000/60%60);  
                 s = Math.floor(leftTime/1000%60);                     
             }
             //将0-9的数字前面加上0，例1变为01
             //d = checkTime(d);
             h = checkTime(h);
             m = checkTime(m);
             s = checkTime(s);
             function checkTime(i){
                 if (i<10) {
                     i = "0"+i;
                 }
                 return i;
             }
             //将倒计时赋值到div中   var timer = d+'天'+h+'时'+m+'分'+s+'秒'
              var timer = h+'：'+m+'：'+ s
             //递归每秒调用countTime方法，显示动态时间效果  
             setTimeout(countTime,1000);
             return timer
         }
	var clear
	import VueRouter from "vue-router";
	import settlement from "@/components/settlementList"
	export default {
		name: 'settlement',
		data() {
			return {
				select:{
					year:'',
					status:''
				},
				status:[
					{
						num:'1',
						value:'待审核'
					},
					{
						num:'2',
						value:'已审核'
					},
					{
						num:'3',
						value:'已处理'
					}
				],
				years:[],
				total:0,
				page:0,
				pageSize:15,
				meterList:[],
			}
		},
		created:function(){
			
			this.postYears()
			this.seachSettleMent()
		},
		methods:{
			postYears(){
				window.clearInterval(clear)
				this.$jssdk.refund.getTime({
					
				},(res) =>{
					this.years = res
				})
			},
			seachSettleMent(){
				var that = this
				clear = window.setInterval(function(){
					that.$jssdk.refund.list({
						year:that.select.year,
						status:that.select.status,
						page:that.page
					},(res) =>{
						that.meterList = res.data
						that.total = res.total
						for(var i=0;i<that.meterList.length;i++){
							if(that.meterList[i].type == '1'){
								that.meterList[i].dueTime = countTime(that.meterList[i].due_time)
							}else{
								that.meterList[i].dueTime = ''
							}
							
						}
					},(err) =>{
						this.$message({
							type:'warning',
							message:err.data,
							duration:2000
						})
					})
				},1000)
				
			},
			returnSearch(){
				this.select.year = ''
				this.select.status = ''
			},
			jumpInfo(scope){
				window.clearInterval(clear)
				this.$router.push({ name: 'settlementList', params: {year:scope.year,build:scope.community_id}})
				console.log(scope.year)
			},
			sureStatus(scope){
				 this.$confirm('确定审核?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		         	this.$jssdk.refund.auditing({
		         		id:scope.id
		         	},(res) =>{
		         		 this.$message({
				            type: 'success',
				            message:res
				          });  
		         	},(err) =>{
		         		this.$message({
				            type: 'warning',
				            message:res
				          });
		         	})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消'
		          });          
		        });
			},
			handleSizeChange(val){
				
			},
			handleCurrentChange(val){
				window.clearInterval(clear)
				var that = this
				clear = window.setInterval(function(){
					that.$jssdk.refund.list({
						year:that.select.year,
						status:that.select.status,
						page:val
					},(res) =>{
						that.meterList = res.data
						that.total = res.total
						for(var i=0;i<that.meterList.length;i++){
							that.meterList[i].dueTime = countTime(that.meterList[i].due_time)
						}
					},(err) =>{
						this.$message({
							type:'warning',
							message:err.data,
							duration:2000
						})
					})
				},1000)
			}
		},
		watch:{
			watch(){
				console.log(this.$route.path)
				/*if(this.$route.path !='/settlement'){
					window.clearInterval(clear)
					console.log('a')
				}*/
			}
		},
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// settlement.vue?d3292330